import { render, staticRenderFns } from "./addResume.vue?vue&type=template&id=5a17c910&scoped=true"
import script from "./addResume.vue?vue&type=script&lang=js"
export * from "./addResume.vue?vue&type=script&lang=js"
import style0 from "./addResume.vue?vue&type=style&index=0&id=5a17c910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a17c910",
  null
  
)

export default component.exports